import { IUsersGuideServiceMock } from "./usersguide.types";

export const mockUsersGuideService = (): IUsersGuideServiceMock => ({
  getUsersGuide: jest.fn(),
});
